import ButtonNew from 'presentation/shared/components/ButtonNew'
import styled, { createGlobalStyle, css } from 'styled-components'

export type WizardContainerProps = {
  position: 'top' | 'bottom'
}

/* Global style injection to remove internal ContainerNew scrolls */
export const HideParentScrolls = createGlobalStyle`
  main, main > div {
    overflow-y: hidden !important;

    @media (max-width: 959px) {
      overflow-y: visible !important;
    }
  }
`

export const WizardContainer = styled.div<WizardContainerProps>`
  display: ${({ position }) => (position === 'bottom' ? 'flex' : 'none')};
  justify-content: center;
  width: 100%;
  margin-bottom: 16px;

  @media (max-width: 959px) {
    display: ${({ position }) => (position === 'top' ? 'flex' : 'none')};
  }
`

export const MobileReviewButton = styled(ButtonNew)`
  ${({ theme }) => css`
    display: none;
    flex: 1;
    font-size: ${theme.ds.typography.size.xxsmall};
    padding: 0;
    height: 32px;
    border-radius: 30px;
    max-width: 180px;
    min-width: 160px;

    @media (max-width: 959px) {
      display: flex;
    }
  `}
`

export const SaveDraftReviewButton = styled(ButtonNew)`
  ${({ theme }) => css`
    display: none;
    flex: 1;
    font-size: ${theme.ds.typography.size.xxsmall};
    padding: 0;
    height: 32px;
    border-radius: 30px;
    max-width: 180px;
    min-width: 160px;
    background-color: ${theme.ds.colors.white};
    border: 1px solid ${theme.ds.colors.primary600};
    color: ${theme.ds.colors.primary600};

    &:hover {
      background-color: ${theme.ds.colors.white};
      border-color: ${theme.ds.colors.primary300};
      color: ${theme.ds.colors.primary300};
    }

    @media (max-width: 959px) {
      display: flex;
    }
  `}
`

export type LayoutWrapperProps = {
  actionBarHeight?: number
}

export const LayoutWrapper = styled.div<LayoutWrapperProps>`
  display: flex;
  flex: 1;
  min-height: 0;
  height: 100%;
  padding-bottom: ${({ actionBarHeight }) =>
    actionBarHeight ? `${actionBarHeight}px` : '5rem'};

  @media (max-width: 959px) {
    flex-direction: column;
    height: auto;
    overflow: visible;
    padding-bottom: ${({ actionBarHeight }) =>
      actionBarHeight ? `${actionBarHeight}px` : '13rem'};
  }
`

export const LayoutMainContent = styled.div`
  flex: 0 0 70%;
  max-width: 70%;
  height: 100%;
  overflow-y: auto;
  overflow-x: visible;
  padding-right: 16px;
  padding-bottom: 16px;

  @media (max-width: 959px) {
    flex: 1 1 auto;
    max-width: 100%;
    width: 100%;
    height: auto;
    padding-right: 0;
    overflow-y: visible;
  }
`

export const LayoutReview = styled.div`
  flex: 0 0 30%;
  max-width: 30%;
  height: 100%;
  overflow-y: auto;
  padding: 0 16px;

  @media (max-width: 959px) {
    flex: 1 1 auto;
    max-width: 100%;
    width: 100%;
    height: auto;
    padding: 0;
  }
`

export const ActionBar = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  display: flex;
  flex-direction: column;
  align-items: end;
  justify-content: flex-end;
  padding: 16px 24px;
  background: #fff;
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.08);

  @media (max-width: 959px) {
    padding: 24px;
    justify-content: center;
    gap: 8px;
  }
`

export const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  @media (max-width: 959px) {
    width: 100%;
    flex-direction: column-reverse;
    justify-content: center;

    > button {
      width: 100%;
    }
  }
`

export const ReviewButtonGroup = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
`
